import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const quoteStatusesAdapter = getAdapter({ idFieldName: 'value' });

const quoteStatusesSlice = createSlice({
  name: 'quoteStatuses',
  initialState: quoteStatusesAdapter.getInitialState(),
  reducers: {
    setQuoteStatuses: (state, { payload: { quoteStatuses } }) => {
      quoteStatusesAdapter.setAll(state, quoteStatuses);
    },
  },
});

const selectors = quoteStatusesAdapter.getSelectors(({ quoteStatuses }) => quoteStatuses);

export const getQuoteStatuses = (state) => selectors.selectAll(state);

export const {
  setQuoteStatuses,
} = quoteStatusesSlice.actions;

export default quoteStatusesSlice.reducer;
